import { useEffect, useState } from "react";
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import AboutVideo from "@/components/AboutVideo/AboutVideo";
import OurLocations from "@/components/OurLocations/OurLocations";
import ContactInformation from "@/components/ContacInformation/ContactInformation";
import BannerCommon from "@/components/BnnnerCommon/BannerCommon";
import { aboutBanner } from "@/components/BnnnerCommon/BannerCommonData";
import { fetchContactData } from "@/services/CmsService";
import Layout from "@/components/Layout/Layout";
import { fetchCommonData } from "@/services/CommonService";
import PopupForm from "@/components/PopupForm/PopupForm";
import StickyFooter from "@/components/StickyFooter/StickyFooter";
import ContactForm from "@/components/ContactForm/ContactForm";

interface ContactProps {
  commonData: any;
  cmsContactPage: {
    [key: string]: any;
  } | null;
}

export default function Contact({ cmsContactPage, commonData }: ContactProps) {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  // const [redirectlink, setRedirectlink] = useState("");

  useEffect(() => {
    const isPopupShown = localStorage.getItem("isPopupShown");

    if (!isPopupShown) {
      const timer = setTimeout(() => {
        setIsPopupVisible(true);
        localStorage.setItem("isPopupShown", "true");
      }, 800);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  const StickyFooterComponent = cmsContactPage?.sticky_footer
    ?.is_sticky_footer_enabled
    ? cmsContactPage?.sticky_footer
    : commonData?.sticky_footer?.is_sticky_footer_enabled
    ? commonData?.sticky_footer
    : null;

  return (
    <Layout SeoData={cmsContactPage?.seo_data} commonData={commonData}>
      <BannerCommon
        classValue="aboutBanner"
        data={aboutBanner}
        cmsData={cmsContactPage?.banner}
      />
      <div className="breadCrumbStyle">
        <Breadcrumbs classValue="boxStyle" />
      </div>
      <ContactInformation data={cmsContactPage?.contact_information} />
      <ContactForm />
      <OurLocations
        className="contactLocations"
        data={cmsContactPage?.our_locations}
      />

      <AboutVideo
        className="contactLocations"
        data={cmsContactPage?.our_campus_tour}
      />
      <PopupForm
        isVisible={isPopupVisible}
        onClose={handleClosePopup}
        // redirectlink={redirectlink}
      />
      {StickyFooterComponent && <StickyFooter data={StickyFooterComponent} />}
    </Layout>
  );
}

export async function getServerSideProps() {
  try {
    const cmsContactPage = await fetchContactData();
    const response = await fetchCommonData();

    return {
      props: {
        cmsContactPage: cmsContactPage?.data,
        commonData: response.data,
      },
    };
  } catch (error) {
    console.error("Error fetching CMS data:", error);
  }
}
